import React from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';



import Navbar from "../../components/Navbar/Navbar";
import classes from './EditPage.module.css';

import Foot from "../../components/Foot/Foot";

import { useState } from "react";


import db from "../../data/firebase";
import {useHistory} from 'react-router-dom';

import Spinner from 'react-bootstrap/Spinner';

function EditPage(props){
    const [product, setProduct] = useState();
    const [price, setPrice] = useState();
    const [perfumes, setPerfumes]= useState();
    
    let perfumeList=[];
    let currentUrl= window.location.search;
    let urlParams = new URLSearchParams(currentUrl);
    const currentPerfume = urlParams.get('perfume');
    let history= useHistory();
    
    
    let newPerfume={
        name: null,
        gender: null,
        desc: null,
        occasion: null,
        season: null,
        images: [],
        priceAndBottle:[],
        topNote: null,
        middleNote: null,
        baseNote: null,
        stock: null,

    };

  
    let currentBottle=null;
    let currentprice=null;
    let currentImage=null;
    let decantImg=null;
    let currentStock=null;
    


    function checking(){
        let i=0;
        db.collection("perfumes").get().then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
                
                let temp={
                    id: doc.id,
                    data: doc.data(),
                }
                perfumeList[i]=temp;
                i++;
                if(temp.id == currentPerfume){
                    setProduct(temp);
                    updateNewPerfume();
                 
                }
                
                
            });
           
            
            setPerfumes(perfumeList);
           
    
        });
    }

    function updateNewPerfume(){
        if(product){
            newPerfume.name= product.data.name;
        }
    }

  

  
  
   

    // Images
    function getImages(event){
        currentImage=event.target.value;
        // newPerfume.images[newPerfume.images.length]=event.target.value
    
        
    }

    function addImage(){
        let tempPerfume={...product}
        newPerfume.images[newPerfume.images.length]=currentImage;
        tempPerfume.data.images[tempPerfume.data.images.length]=newPerfume.images[newPerfume.images.length-1];
        console.log(product.data.images);
     
        updatePerfume(tempPerfume);
        
        
            
    }

    function updatePerfume(tempPerfume){
        db.collection('perfumes').doc(product.id).set({
            ...tempPerfume.data
        })
        checking();
        

    }

    
    function deleteImage(i){

        
        let tempPerfume={...product}
        tempPerfume.data.images.splice(i, 1);
        {console.log(tempPerfume)}


       
        updatePerfume(tempPerfume);
        

    }

    // Name and Description

    function changeName(event){
       
        newPerfume.name=event.target.value;
        
    }

    function changeDesc(event){
        newPerfume.desc=event.target.value;
    }

    function updateName(){
        let tempPerfume={...product}
        tempPerfume.data.name=newPerfume.name;
        // db.collection('perfumes').doc(product.id).set({
        //     ...tempPerfume.data
        // })
        updatePerfume(tempPerfume);
      
        


    }

    function updateDesc(){
        let tempPerfume={...product}
        tempPerfume.data.desc=newPerfume.desc;
        // db.collection('perfumes').doc(product.id).set({
        //     ...tempPerfume.data
        // })
        updatePerfume(tempPerfume);
        

    }



    // Occasion and season
    
    function changeOccasion(event){
       
        newPerfume.occasion=event.target.value;
        // console.log(newPerfume.name)
    }

    function changeSeason(event){
        newPerfume.season=event.target.value;
    }

    function updateOccasion(){
        let tempPerfume={...product}
        tempPerfume.data.occasion=newPerfume.occasion;
        updatePerfume(tempPerfume);
      
    }

    function updateSeason(){
        let tempPerfume={...product}
        tempPerfume.data.season=newPerfume.season;
        updatePerfume(tempPerfume);
       
    }


    // Notes

    function changeTopNote(event){
       
        newPerfume.topNote=event.target.value;
        
    }

    function changeMiddleNote(event){
       
        newPerfume.middleNote=event.target.value;
        
    }

    function changeBaseNote(event){
       
        newPerfume.baseNote=event.target.value;
        
    }

    function updateTopNote(){
        let tempPerfume={...product}
        tempPerfume.data.topNote=newPerfume.topNote;
        updatePerfume(tempPerfume);
       
    }

    function updateMiddleNote(){
        let tempPerfume={...product}
        tempPerfume.data.middleNote=newPerfume.middleNote;
        updatePerfume(tempPerfume);
       
    }

    function updateBaseNote(){
        let tempPerfume={...product}
        tempPerfume.data.baseNote=newPerfume.baseNote;
        updatePerfume(tempPerfume);
       
    }

      //decant Img
      function getDecantImg(event){
        decantImg=event.target.value;

    }

 

    // price and bottle

    function getBottle(event){
        
        currentBottle=event.target.value;
        
    }

    function getPrice(event){
    
        currentprice=event.target.value;
       
    }

    function confirmBottleAndPrice(){
        if(currentBottle && currentprice){
            newPerfume.priceAndBottle[newPerfume.priceAndBottle.length]={
                bottle: currentBottle,
                price: currentprice,
                image: decantImg,
            }
        }
        currentBottle=null;
        currentprice=null;
        decantImg=null;

        
        // console.log(newPerfume.priceAndBottle);

    }

    function updateBottleAndPrice(){
        let tempPerfume={...product};
        if(newPerfume.priceAndBottle.length === 0){
            newPerfume.priceAndBottle[0]={
                bottle: "xxx",
                price: "yyy",
                image: "xxx",
            }
        }
        tempPerfume.data.priceAndBottle=newPerfume.priceAndBottle;
        // console.log(tempPerfume.data.priceAndBottle)


        // db.collection('perfumes').doc(product.id).set({
        //     ...tempPerfume.data
        // })
        updatePerfume(tempPerfume);

    }

    function deletePerfume(){
        db.collection('perfumes').doc(product.id).delete().then(function() {
            console.log("Document successfully deleted!");
        }).catch(function(error) {
            console.error("Error removing document: ", error);
        });

        history.push("/adminedit/rifatnrakib")
    }

    function getStock(event){
     
        currentStock=event.target.value;
        let tempPerfume={...product};
        tempPerfume.data.stock=currentStock;
        updatePerfume(tempPerfume);


    }

 


    

    return(
        <div>
            {perfumes? null: checking()} 
               
        <Navbar/>
        {product?
        <div className={classes.box}>


            <h2>Images</h2>
            <label className={classes.title}>Add image:</label>
            <div>
                <input onChange={getImages} className={classes.info} type="text" placeholder="image"/>
            </div>
            <button onClick={addImage}>Add Image</button>
            <div className={classes.images}>
                
                {product? product.data.images.map((image, i)=>(
                    <div>
                    
                    <img className={classes.image} src={image}/>
                    {product.data.images.length>1? <button onClick={()=>deleteImage(i)}>Delete</button>: null}
                    
                    </div>
                )) : null}
            </div>
        {/* name and desc */}

            <div className={classes.name}>
                
                
            <div className={classes.about}>
                        <h5>Change Name</h5>
                    {product? <input className={classes.info}  onChange={changeName} type="text" value={newPerfume.name}/>: null }
                    <button onClick={updateName}>Confirm</button>

            </div>
            <div className={classes.currentValue}>
                     <h2>Current: {product.data.name}</h2>
             </div>

        <div className={classes.desc}>
              
                    {/* <h2>{product.data.desc}</h2> */}
                   <h5>Change Description</h5>
                   {product? <textarea className={classes.info}  onChange={changeDesc} type="text" value={newPerfume.desc}/>: null }
                   <button onClick={updateDesc}>Confirm</button>
                   <div className={classes.currentValue}>
                     <h2>Current: {product.data.desc}</h2>
                    </div>
                   

{/* season and occasion */}
                   <h4>Season</h4>
                   {product? <input className={classes.info}  onChange={changeSeason} type="text" value={newPerfume.name}/>: null }
                   <button onClick={updateSeason}>Confirm</button>
                   <div className={classes.currentValue}>
                     <h2>Current: {product.data.season}</h2>
                 </div>
                   
                  
                   <h4>Occasion</h4>
                   {product? <textarea  className={classes.info}  onChange={changeOccasion} type="text" value={newPerfume.desc}/>: null }
                   <button onClick={updateOccasion}>Confirm</button>
                   <div className={classes.currentValue}>
                     <h2>Current: {product.data.occasion}</h2>
                </div>





                {/* Notes */}


                <h4>Top Note</h4>
                   {product? <input className={classes.info}  onChange={changeTopNote} type="text" value={newPerfume.name}/>: null }
                   <button onClick={updateTopNote}>Confirm</button>
                   <div className={classes.currentValue}>
                     <h2>Current: {product.data.topNote}</h2>
                 </div>
                   
                  
                   <h4>Middle Note</h4>
                   {product? <textarea className={classes.info} onChange={changeMiddleNote} type="text" value={newPerfume.desc}/>: null }
                   <button onClick={updateMiddleNote}>Confirm</button>
                   <div className={classes.currentValue}>
                     <h2>Current: {product.data.middleNote}</h2>
                </div>


                <h4>Base Note</h4>
                   {product? <textarea className={classes.info}  onChange={changeBaseNote} type="text" value={newPerfume.desc}/>: null }
                   <button onClick={updateBaseNote}>Confirm</button>
                   <div className={classes.currentValue}>
                     <h2>Current: {product.data.baseNote}</h2>
                </div>




{/* price and bottle */}

                <h2> Bottles and prices</h2>
                <label className={classes.title}>Bottle size and price:</label>
                <div>
                    <input onChange={getBottle}  className={classes.info} type="text" placeholder="Bottle ml"/>
                    <input onChange={getPrice}  className={classes.info} type="text" placeholder="price"/>
                   
                   
                    <h4>Decant Image</h4>
                        <label className={classes.title}>Add image:</label>
                        <div>
                            <input onChange={getDecantImg} className={classes.info} type="text" placeholder="image"/>
                        </div>
                        {/* <button onClick={addImage}>Add Image</button> */}
                    
                    
                    <div>
                   
                        <input onChange={confirmBottleAndPrice} type="radio" id="done" name="select" value="done"/>
                        <label className={classes.radio}  for="done">Done</label>
                     
              </div>
                </div>

                <label className={classes.title}>Bottle size and price:</label>
                <div>
                    <input onChange={getBottle}  className={classes.info} type="text" placeholder="Bottle ml"/>
                    <input onChange={getPrice}  className={classes.info} type="text" placeholder="price"/>
                    <h4>Decant Image</h4>
                        <label className={classes.title}>Add image:</label>
                        <div>
                            <input onChange={getDecantImg} className={classes.info} type="text" placeholder="image"/>
                        </div>
                    
                    <div>
                   
                        <input onChange={confirmBottleAndPrice} type="radio" id="done" name="select" value="done"/>
                        <label className={classes.radio}  for="done">Done</label>
                     
              </div>
                </div>

                <label className={classes.title}>Bottle size and price:</label>
                <div>
                    <input onChange={getBottle}  className={classes.info} type="text" placeholder="Bottle ml"/>
                    <input onChange={getPrice}  className={classes.info} type="text" placeholder="price"/>
                    <h4>Decant Image</h4>
                        <label className={classes.title}>Add image:</label>
                        <div>
                            <input onChange={getDecantImg} className={classes.info} type="text" placeholder="image"/>
                        </div>
                    <div>
                   
                        <input onChange={confirmBottleAndPrice} type="radio" id="done" name="select" value="done"/>
                        <label className={classes.radio}  for="done">Done</label>
                     
              </div>
                </div>

                <label className={classes.title}>Bottle size and price:</label>
                <div>
                    <input onChange={getBottle}  className={classes.info} type="text" placeholder="Bottle ml"/>
                    <input onChange={getPrice}  className={classes.info} type="text" placeholder="price"/>

                    <h4>Decant Image</h4>
                        <label className={classes.title}>Add image:</label>
                        <div>
                            <input onChange={getDecantImg} className={classes.info} type="text" placeholder="image"/>
                        </div>
                    <div>
                   
                        <input onChange={confirmBottleAndPrice} type="radio" id="done" name="select" value="done"/>
                        <label className={classes.radio}  for="done">Done</label>
                     
              </div>
                </div>


                <label className={classes.title}>Bottle size and price:</label>
                <div>
                    <input onChange={getBottle}  className={classes.info} type="text" placeholder="Bottle ml"/>
                    <input onChange={getPrice}  className={classes.info} type="text" placeholder="price"/>

                    <h4>Decant Image</h4>
                        <label className={classes.title}>Add image:</label>
                        <div>
                            <input onChange={getDecantImg} className={classes.info} type="text" placeholder="image"/>
                        </div>
                    <div>
                   
                        <input onChange={confirmBottleAndPrice} type="radio" id="done" name="select" value="done"/>
                        <label className={classes.radio}  for="done">Done</label>
                     
              </div>
                </div>
                <button onClick={updateBottleAndPrice}>Confirm</button>

                
                      {product.data.priceAndBottle.map((each)=>(
                         <div className={classes.currentValue}>
                             <h2>Current:[{each.bottle}ml : {each.price}BDT]</h2>
                             <img className={classes.decantImg} src={each.image}/>

                         </div>

                     ) )}



                <label className={classes.title}><h3>Stock </h3></label>
                 
                 <div >
                    <input onChange={getStock} type="radio" id="available" name="stock" value="available"/>
                    <label className={classes.radio}  for="available">Available</label>
                    <input onChange={getStock} type="radio" id="out" name="stock" value="out"/>
                    <label className={classes.radio} for="out">Out</label>
                 
                </div>

                <div className={classes.currentValue}>
                     <h2>Current: {product.data.stock}</h2>
                </div>

       
                






                   
                </div>

        </div>

        </div> : <Spinner animation="border" />}
        <div>
             <button onClick={deletePerfume}>Delete Perfume</button>

        </div>
        
        


        
       
        

          

        <Foot/>
        
        
       

       
      </div>
    )
}


export default EditPage;   